import React from 'react';
import { SvgIconProps } from '@material-ui/core';
import mainColors from '../../../../themes/main-colors';

interface CustomIconProps extends Omit<SvgIconProps, 'color'> {
  color?: string;
  size?: number;
}

const CommercialIcon = ({
  size = 48,
  color = mainColors.wizardBlue,
  ...props
}: CustomIconProps) => {
  const shadow = 'drop-shadow(0px 0px 5px rgba(0,0,0,0.5))';

  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 58 58"
      fill="none"
      style={{ filter: shadow }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect x="6" y="6" width="46" height="46" rx="23" fill={color} />
        <rect
          x="7"
          y="7"
          width="44"
          height="44"
          rx="22"
          stroke="white"
          strokeWidth="2"
        />
        <mask
          id="mask0_9412_33575"
          maskUnits="userSpaceOnUse"
          x="17"
          y="17"
          width="24"
          height="24"
        >
          <rect x="17" y="17" width="24" height="24" fill="#FFFFFF" />
        </mask>
        <g mask="url(#mask0_9412_33575)">
          <path
            d="M34.1155 25.8845H35.8845V24.1155H34.1155V25.8845ZM34.1155 29.8845H35.8845V28.1155H34.1155V29.8845ZM34.1155 33.8845H35.8845V32.1155H34.1155V33.8845ZM18.5 37.5V28.25L25 23.6155L31.5 28.25V37.5H26.923V31.9615H23.077V37.5H18.5ZM33.5 37.5V27.25L27.1923 22.7098V20.5H39.5V37.5H33.5Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};

export default CommercialIcon;
